export const GET_VOTE_RECORDS = 'GET_VOTE_RECORDS';
export const GET_VOTE_RECORDS_SUCCESS = 'GET_VOTE_RECORDS_SUCCESS';
export const GET_VOTE_RECORDS_ADDENDUM = 'GET_VOTE_RECORDS_ADDENDUM';
export const GET_VOTE_RECORDS_ADDENDUM_SUCCESS = 'GET_VOTE_RECORDS_ADDENDUM_SUCCESS';
export const GET_VOTE_RECORDS_PN1789 = 'GET_VOTE_RECORDS_PN1789';
export const GET_VOTE_RECORDS_PN1789_SUCCESS = 'GET_VOTE_RECORDS_PN1789_SUCCESS';
export const GET_VOTE_RECORDS_BIG_BEAUTIFUL_BILL = 'GET_VOTE_RECORDS_BIG_BEAUTIFUL_BILL';
export const GET_VOTE_RECORDS_BIG_BEAUTIFUL_BILL_SUCCESS = 'GET_VOTE_RECORDS_BIG_BEAUTIFUL_BILL_SUCCESS';
export const GET_VOTE_RECORDS_BIG_BEAUTIFUL_HOUSE2 = 'GET_VOTE_RECORDS_BIG_BEAUTIFUL_HOUSE2';
export const GET_VOTE_RECORDS_BIG_BEAUTIFUL_HOUSE2_SUCCESS = 'GET_VOTE_RECORDS_BIG_BEAUTIFUL_HOUSE2_SUCCESS';
export const GET_VOTE_RECORDS_FLEXIBILITY = 'GET_VOTE_RECORDS_FLEXIBILITY';
export const GET_VOTE_RECORDS_FLEXIBILITY_SUCCESS = 'GET_VOTE_RECORDS_FLEXIBILITY_SUCCESS';
export const GET_VOTE_RECORDS_PRUDENT = 'GET_VOTE_RECORDS_PRUDENT';
export const GET_VOTE_RECORDS_PRUDENT_SUCCESS = 'GET_VOTE_RECORDS_PRUDENT_SUCCESS';
export const GET_CURRENT_MEMBERS_OF_CONGRESS = 'GET_CURRENT_MEMBERS_OF_CONGRESS';
export const GET_CURRENT_MEMBERS_OF_CONGRESS_SUCCESS = 'GET_CURRENT_MEMBERS_OF_CONGRESS_SUCCESS';
export const GET_NEW_MEMBERS_OF_CONGRESS = 'GET_NEW_MEMBERS_OF_CONGRESS';
export const GET_NEW_MEMBERS_OF_CONGRESS_SUCCESS = 'GET_NEW_MEMBERS_OF_CONGRESS_SUCCESS';
export const GET_LOCAL_CONGRESSIONAL_DISTRICTS = 'GET_LOCAL_CONGRESSIONAL_DISTRICTS';
export const GET_LOCAL_CONGRESSIONAL_DISTRICTS_SUCCESS = 'GET_LOCAL_CONGRESSIONAL_DISTRICTS_SUCCESS';
export const GET_ADDRESS_SEARCH_RESULTS = 'GET_ADDRESS_SEARCH_RESULTS';
export const GET_ADDRESS_SEARCH_RESULTS_SUCCESS = 'GET_ADDRESS_SEARCH_RESULTS_SUCCESS';
export const GET_DISTRICT_SEARCH_RESULTS_SUCCESS = 'GET_DISTRICT_SEARCH_RESULTS_SUCCESS';
export const GET_CURRENT_MEMBERS_OF_CONGRESS_DETAILS = 'GET_CURRENT_MEMBERS_OF_CONGRESS_DETAILS';
export const GET_CURRENT_MEMBERS_OF_CONGRESS_DETAILS_LOCAL = 'GET_CURRENT_MEMBERS_OF_CONGRESS_DETAILS_LOCAL';
export const GET_CURRENT_MEMBERS_OF_CONGRESS_DETAILS_SUCCESS = 'GET_CURRENT_MEMBERS_OF_CONGRESS_DETAILS_SUCCESS';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const ACTION_ERROR = 'ACTION_ERROR';

